import { render } from "./MonthCalendar.vue?vue&type=template&id=1d63abe0&scoped=true"
import script from "./MonthCalendar.vue?vue&type=script&lang=ts"
export * from "./MonthCalendar.vue?vue&type=script&lang=ts"

import "./MonthCalendar.vue?vue&type=style&index=0&id=1d63abe0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d63abe0"

export default script